import { render, staticRenderFns } from "./SearchRecord.vue?vue&type=template&id=32371c30&scoped=true"
import script from "./SearchRecord.vue?vue&type=script&lang=js"
export * from "./SearchRecord.vue?vue&type=script&lang=js"
import style0 from "./SearchRecord.vue?vue&type=style&index=0&id=32371c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32371c30",
  null
  
)

export default component.exports